import { PlusIcon } from '@heroicons/react/20/solid';
import Page from '../../../../components/PageWrapper';
import { useMemo, useState } from 'react';
import { getAllExpenses } from '../../../../api/requests';
import GTable from '../../../../components/elements/GTable';
import { ITablePaginationData } from '../../../../components/elements/GTable/GTable';
import Loader from '../../../../components/Loader';
import useModal from '../../../../hooks/modalHook';
import Button from '../../../../components/form-control/Button';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import CreateExpense from './CreateExpense';
import moment from 'moment';
import { Expense } from '../../../../models/expense/Expense';
import { useNavigate } from 'react-router';
import { IExpense } from '../../../../models/expense/IExpense';
import useRoute from '../../../../hooks/routesHook';
import ExpenseDetails from './ExpenseDetailsView';
import useExpenses from '../../../../hooks/expensesHook';
import { getFormattedDate } from '../../../../utils/miscFunctions';

interface ExpenseProps {
    isSettings?: boolean;
}
const Expenses = ({isSettings = false}: ExpenseProps): JSX.Element => {
    const [expenses, setExpenses] = useState<any>([]);
    const [searchString, setSearchString] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(true);
    const { getDashboardBase } = useRoute();
    const [expensesPaginationData, setExpensesPaginationData] = useState<ITablePaginationData>();
    const [showPerPage, setShowPerPage] = useState<number>(100);
    const { ModalComponent, updateModalStates, closeModal } = useModal();
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const {addExpense, ExpenseModal} = useExpenses();

    const { } = useQuery({ queryFn: () => getExpenses(), queryKey: ["getExpenses", showPerPage, searchString] })

   
    const showExpenseDetails = (expense: IExpense) => {
        expense &&
            updateModalStates({
                show: true,
                size: '2xl',
                children: (
                    <ExpenseDetails expense={expense} />
                ),
                classes: '!p-0 r-[5px]'
            });
    };

    const getExpenses = () => {
        getAllExpenses()
            .then((response: any) => {
                const expenses = response?.data.map((expense: any, index: number) => new Expense(expense))

                setExpenses(expenses);

            }).catch(() => { })
            .finally(() => setLoading(false))
    };

    const columns = useMemo(
        () => [
            {
                Header: 'M',
                columns: [
                    {
                        Header: 'Title',
                        accessor: 'title',
                        Cell: (row: any) => {
                            return <span>{row.cell.value ? row.cell.value : '-'}</span>;
                        }
                    },
                    {
                        Header: 'Category',
                        accessor: 'category',
                        Cell: (row: any) => {
                            return <span>{row.cell.value ? row.cell.value : '-'}</span>;
                        }
                    },
                    {
                        Header: 'Description',
                        accessor: 'description',
                        Cell: (row: any) => {
                            return <span>{row.cell.value ? row.cell.value : '-'}</span>;
                        }
                    },

                    {
                        Header: 'Amount',
                        accessor: 'amount',
                        Cell: (row: any) => {
                            return <span>{row.cell.value ? row.row.original.currency + " " + row.cell.value : '-'}</span>;
                        }
                    }, {
                        Header: 'DoT',
                        accessor: 'dateOfTransaction',
                        Cell: (row: any) => {
                            return <span>{row.cell.value ? getFormattedDate({ date: row.cell.value, showTime: true }) : '-'}</span>;
                        }
                    },
                    {
                        Header: 'Created By',
                        accessor: 'staff.fullName',
                        Cell: (row: any) => {
                            return <span>{row.cell.value ? row.cell.value : '-'}</span>;
                        }
                    },

                    {
                        Header: 'Created On',
                        accessor: 'createdOn',
                        Cell: (row: any) => {
                            return <span>{row.cell.value ? getFormattedDate({ date: row.cell.value, showTime: true }) : '-'}</span>;
                        }
                    },

                ]
            }
        ],
        []
    );

    return (
        <Page title="Expenses">
            <div className="bg-white dark:bg-darkBg p-5 h-full">
               {!loading && !isSettings && <div className="flex items-center justify-between  ">
                   
                    <div className=" flex justify-end items-center">
                        <div className="">
                            <Button
                                icon={<PlusIcon width="20px" height="20px" className="mr-2" />}
                                className="p-2 h-[40px] rounded"
                                bgColor="primary"
                                label="Add Expense"
                                onClick={addExpense}
                            />
                        </div>
                    </div>
                </div>}

                <div className=" w-full">
                    {loading ? (
                     
                            <Loader message="Fetching expenses. Please wait..." brollyLoaderFixed  />
                        
                    ) : (
                        <div className="overflow-x-auto mt-4 bg-white dark:bg-darkBg">
                            <GTable
                                selectionChanged={(selection: any) => {
                                    // setSlcMember(selection);
                                }}
                                columns={columns}
                                data={expenses}
                                onSearch={(searchString: string) => setSearchString(searchString)}
                                tableType={'expense'}
                                loading={loading}
                                paginationData={expensesPaginationData}
                                onRowClick={(expense: IExpense) => showExpenseDetails(expense)}
                                // onRowClick={(expense: IExpense) => navigate(`${getDashboardBase()}/expenses/${expense?.id}`, { replace: true })}
                                // onPageChange={handlePageChange}
                                showPerPage={showPerPage}
                                showSearch={false}
                                onShowPerPageChange={(page: number) => setShowPerPage(page)}
                            />
                        </div>
                    )}
                </div>
            </div>
            <ModalComponent />
            <ExpenseModal />
        </Page>
    );
};

export default Expenses;
